"use client";

import { useState } from "react";

interface CopyOemProps {
  code: string;
  className?: string;
  as?: "strong" | "code" | "span";
}

export function CopyOem({ code, className = "", as = "strong" }: CopyOemProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = code;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.warn("Failed to copy OEM:", err);
    }
  }

  const Tag = as;

  return (
    <Tag
      className={`pub-copyable-oem ${className}`.trim()}
      onClick={handleCopy}
      data-copied={copied ? "true" : "false"}
      title={copied ? "Скопировано в буфер обмена!" : "Нажмите, чтобы скопировать артикул"}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCopy(e as unknown as React.MouseEvent);
        }
      }}
    >
      <span>{code}</span>
      <span className="pub-copyable-icon" aria-hidden="true">
        {copied ? (
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </span>
      {copied ? (
        <span className="pub-copyable-toast" role="status" aria-live="polite">
          Скопировано!
        </span>
      ) : null}
    </Tag>
  );
}
